import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'your-supabase-url'
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'your-supabase-anon-key'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Storage bucket names
export const STORAGE_BUCKETS = {
  COMPLAINT_IMAGES: 'complaint-images',
  PROOF_IMAGES: 'proof-images'
}

// Real-time subscriptions
export const subscribeToComplaints = (callback: (payload: any) => void) => {
  return supabase
    .channel('complaints')
    .on('postgres_changes', { event: '*', schema: 'public', table: 'complaints' }, callback)
    .subscribe()
}

export const subscribeToStatusLogs = (callback: (payload: any) => void) => {
  return supabase
    .channel('status_logs')
    .on('postgres_changes', { event: '*', schema: 'public', table: 'status_logs' }, callback)
    .subscribe()
}
